import { useState } from 'react';

function CardOne() {
  const [imgError, setImgError] = useState(false);
  return (
    <div className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-default">
      <div className="aspect-[3/4] bg-background-100 relative overflow-hidden">
        {!imgError ? (
          <img
            src="https://readdy.ai/api/search-image?query=Manga%20cover%20style%20illustration%20of%20a%20beautiful%20princess%20in%20elegant%20gown%20standing%20in%20a%20magical%20palace%20garden%2C%20Korean%20webtoon%20art%20style%2C%20soft%20pastel%20pink%20and%20gold%20color%20palette%2C%20decorative%20floral%20frame%2C%20clean%20composition%20on%20cream%20background%2C%20professional%20comic%20cover%20design&width=600&height=800&seq=card-comic-01&orientation=portrait"
            alt="反派千金的生存法则 - 韩漫奇幻热门推荐"
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-foreground-400">
            <i className="ri-book-line text-4xl"></i>
          </div>
        )}
        <div className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium">9.9</div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm font-heading font-bold text-foreground-900 truncate">反派千金的生存法则</h3>
        <p className="text-xs text-foreground-500 mt-1">韩漫 · 奇幻 · 连载中</p>
      </div>
    </div>
  );
}

function CardTwo() {
  const [imgError, setImgError] = useState(false);
  return (
    <div className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-default">
      <div className="aspect-[3/4] bg-background-100 relative overflow-hidden">
        {!imgError ? (
          <img
            src="https://readdy.ai/api/search-image?query=Manga%20cover%20style%20illustration%20of%20a%20swordsman%20character%20with%20flowing%20cape%20in%20dynamic%20action%20pose%2C%20Japanese%20shonen%20manga%20art%20style%2C%20bold%20red%20and%20golden%20color%20palette%2C%20speed%20lines%20and%20dramatic%20lighting%20effects%2C%20clean%20composition%20on%20dark%20background%2C%20professional%20comic%20cover%20design&width=600&height=800&seq=card-comic-02&orientation=portrait"
            alt="剑术名家的独女 - 韩漫恋爱热门推荐"
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-foreground-400">
            <i className="ri-book-line text-4xl"></i>
          </div>
        )}
        <div className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium">9.8</div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm font-heading font-bold text-foreground-900 truncate">剑术名家的独女</h3>
        <p className="text-xs text-foreground-500 mt-1">韩漫 · 恋爱 · 连载中</p>
      </div>
    </div>
  );
}

function CardThree() {
  const [imgError, setImgError] = useState(false);
  return (
    <div className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-default">
      <div className="aspect-[3/4] bg-background-100 relative overflow-hidden">
        {!imgError ? (
          <img
            src="https://readdy.ai/api/search-image?query=Manga%20cover%20style%20illustration%20of%20a%20mysterious%20character%20with%20dark%20hair%20casting%20a%20powerful%20spell%2C%20supernatural%20theme%20with%20glowing%20cursed%20energy%2C%20Japanese%20dark%20fantasy%20manga%20art%20style%2C%20deep%20purple%20and%20dark%20gold%20color%20palette%2C%20dramatic%20composition%2C%20professional%20comic%20cover%20design&width=600&height=800&seq=card-comic-03&orientation=portrait"
            alt="咒术回战 - 日漫热血人气作品"
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-foreground-400">
            <i className="ri-book-line text-4xl"></i>
          </div>
        )}
        <div className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium">9.7</div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm font-heading font-bold text-foreground-900 truncate">咒术回战</h3>
        <p className="text-xs text-foreground-500 mt-1">日漫 · 热血 · 连载中</p>
      </div>
    </div>
  );
}

function CardFour() {
  const [imgError, setImgError] = useState(false);
  return (
    <div className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-default">
      <div className="aspect-[3/4] bg-background-100 relative overflow-hidden">
        {!imgError ? (
          <img
            src="https://readdy.ai/api/search-image?query=Manga%20cover%20style%20illustration%20of%20a%20cute%20girl%20in%20royal%20princess%20dress%20holding%20a%20small%20dragon%20companion%2C%20Korean%20webtoon%20fantasy%20style%2C%20light%20and%20cheerful%20pastel%20color%20palette%20with%20sparkles%2C%20decorative%20floral%20border%2C%20clean%20composition%2C%20professional%20comic%20cover%20design&width=600&height=800&seq=card-comic-04&orientation=portrait"
            alt="某天成为公主 - 韩漫奇幻热门推荐"
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-foreground-400">
            <i className="ri-book-line text-4xl"></i>
          </div>
        )}
        <div className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium">9.6</div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm font-heading font-bold text-foreground-900 truncate">某天成为公主</h3>
        <p className="text-xs text-foreground-500 mt-1">韩漫 · 奇幻 · 连载中</p>
      </div>
    </div>
  );
}

function CardFive() {
  const [imgError, setImgError] = useState(false);
  return (
    <div className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-default">
      <div className="aspect-[3/4] bg-background-100 relative overflow-hidden">
        {!imgError ? (
          <img
            src="https://readdy.ai/api/search-image?query=Manga%20cover%20style%20illustration%20of%20a%20martial%20artist%20in%20traditional%20Chinese%20robe%20performing%20a%20powerful%20technique%2C%20Chinese%20manhua%20wuxia%20style%2C%20bold%20black%20ink%20and%20warm%20golden%20color%20palette%2C%20dramatic%20brushstroke%20effects%2C%20clean%20composition%2C%20professional%20comic%20cover%20design&width=600&height=800&seq=card-comic-05&orientation=portrait"
            alt="镖人 - 国漫热血人气作品"
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-foreground-400">
            <i className="ri-book-line text-4xl"></i>
          </div>
        )}
        <div className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium">9.3</div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm font-heading font-bold text-foreground-900 truncate">镖人</h3>
        <p className="text-xs text-foreground-500 mt-1">国漫 · 热血 · 连载中</p>
      </div>
    </div>
  );
}

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精选漫画
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            编辑团队为你精选的高分热门漫画，每一部都值得从头追到尾
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          <CardOne />
          <CardTwo />
          <CardThree />
          <CardFour />
          <CardFive />
        </div>
      </div>
    </section>
  );
}